import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  tile: null,
};

export const wheelSlice = createSlice({
  name: 'wheel',
  initialState,
  reducers: {
    setWheel: (state, action) => {
      state.tile = action.payload;
    },

    clearWheel: (state) => {
      state.tile = null;
    },
  },
});

export const { setWheel, clearWheel } = wheelSlice.actions;
export const selectWheel = (state) => state.wheel.tile;
export default wheelSlice.reducer;
